import React, { FC, PropsWithChildren, useEffect, useState } from "react";

import { AppInsightsContext, ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import config from "@/config";

import { ApplicationInsightsContext } from "./applicationInsightsContext";
import { IApplicationInsightsState } from "./applicationInsightsState";
import { defaultTelemetryInitializer } from "./applicationInsightsTelemetry";

type ApplicationInsightsContextProviderType = {
    disabled?: boolean;
};

export const ApplicationInsightsContextProvider: FC<PropsWithChildren<ApplicationInsightsContextProviderType>> = ({
    children,
    disabled = false,
}) => {
    const [state, setState] = useState<IApplicationInsightsState>({
        ApplicationInsights: undefined,
        ReactPlugin: undefined,
    });

    useEffect(() => {
        if (!disabled) {
            const reactPlugin = new ReactPlugin();
            const appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: config.APPINSIGHTS.INSTRUMENTATIONKEY,
                    enableAutoRouteTracking: true,
                    extensions: [reactPlugin],
                },
            });
            setState(() => ({
                ReactPlugin: reactPlugin,
                ApplicationInsights: appInsights,
            }));
        }
    }, []);

    useEffect(() => {
        const insights = state.ApplicationInsights;
        if (insights) {
            insights.loadAppInsights();
            insights.addTelemetryInitializer(defaultTelemetryInitializer);
        }
    }, [state.ApplicationInsights]);

    return (
        <ApplicationInsightsContext.Provider value={state}>
            <AppInsightsContext.Provider value={state.ReactPlugin}>{children}</AppInsightsContext.Provider>
        </ApplicationInsightsContext.Provider>
    );
};
